import React from 'react';
import { connect } from 'react-redux';

import { resendEmailConfirmation, reset } from '../../../../redux/auth/resendEmailConfirmation/actions';

import ResendEmailConfirmationModal from './ResendEmailConfirmationModal';

import * as selectors from './selectors';

const ResendEmailConfirmationModalConnected = (props) => <ResendEmailConfirmationModal {...props} />;

const mapDispatchToProps = (state) => ({
  isLoading: selectors.selectIsLoading(state),
  error: selectors.selectError(state),
  errorMessage: selectors.selectErrorMessage(state),
});

const mapActionsToProps = {
  resendEmailConfirmation,
  reset,
};

export default connect(mapDispatchToProps, mapActionsToProps)(ResendEmailConfirmationModalConnected);
